/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Flex, Typography } from "../..";
import { iconMap } from "./ContentsBanner.constants";
import { containerCSS, typeStyle, variantStyle } from "./ContentsBanner.css";
import type { ContentsBannerProps } from "./ContentsBanner.types";

export const ContentsBanner = ({
  text,
  type,
  className,
  sx,
  button,
  as: Element = "div",
  children,
  title,
  variant = "default",
  native,
}: ContentsBannerProps) => {
  return (
    <Element
      className={className}
      css={[variantStyle[variant], typeStyle[type], containerCSS({ type, title, variant }), sx]}
      {...native}
    >
      {type !== "primary" && (
        <Flex
          minWidth="16px"
          alignSelf="flex-start"
          padding={type !== "minimal" ? `${vars.spacing[1]} 0` : 0}
        >
          {iconMap[variant]}
        </Flex>
      )}

      <Flex
        flexDirection="column"
        gap={vars.spacing[2]}
        padding={type === "secondary" ? `${vars.spacing["05"]} 0` : 0}
      >
        {title && (
          <Typography
            whiteSpace="pre-wrap"
            semanticToken={type === "minimal" ? "body-small-bold" : "body-medium-bold"}
          >
            {title}
          </Typography>
        )}

        {children || (
          <Typography
            {...(type === "minimal" && { colorToken: "textSub", semanticToken: "body-small" })}
            whiteSpace="pre-wrap"
          >
            {text} {button && <button onClick={button.onClick}>{button.text}</button>}
          </Typography>
        )}
      </Flex>
    </Element>
  );
};
